module.exports = __webpack_public_path__ + "img/PersonalDetails.f2dc6dc9.svg";